import React from "react"
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { cn } from "@/lib/utils"
import TitoAvatar from "@/modules/app/components/tito-avatar"

export type MessageType = "user" | "ai"

interface MessageProps {
  content: string
  type: MessageType
  avatar: {
    href: string
    fallback: string
  } | null
  className?: string
}

const formatBoldText = (text: string) => {
  if (!text) return []

  const parts = text.split(/(\*\*.*?\*\*)/g)

  return parts.map((part, index) => {
    if (part.startsWith("**") && part.endsWith("**")) {
      const boldText = part.slice(2, -2)
      return <strong key={index}>{boldText}</strong>
    }
    return part
  })
}

export const Message: React.FC<MessageProps> = ({ content, type, avatar, className }) => {
  const isUser = type === "user"

  return (
    <div
      className={cn(
        "flex w-full items-end gap-3 py-2",
        isUser ? "justify-end" : "justify-start",
        className,
      )}
    >
      {!isUser && <TitoAvatar />}
      <div
        className={cn(
          "max-w-[80%] break-words px-4 py-3",
          isUser
            ? "rounded-t-2xl rounded-bl-2xl bg-neutral-200 text-black"
            : "rounded-t-2xl rounded-br-2xl bg-primary-50 text-gray-800",
        )}
      >
        {formatBoldText(content)}
      </div>
      {isUser && (
        <Avatar className="h-8 w-8 shrink-0 border">
          <AvatarImage src={avatar?.href || "/api/placeholder/32/32"} alt="Usuario" />
          <AvatarFallback className="bg-blue-100 text-blue-800">{avatar?.fallback}</AvatarFallback>
        </Avatar>
      )}
    </div>
  )
}
